import YDropdownItem from './src/main'

YDropdownItem.install = function(Vue) {
  Vue.component(YDropdownItem.name, YDropdownItem)
}

export default YDropdownItem
